import React, { useEffect, useState } from "react";
import { AuditInfo } from "./AuditInfo";
import { EditInfo } from "./EditInfo";
import * as Audit from "../../Services/EmployeeDB";
import { AuditTrialVM } from "../../Models/ViewModels";
import { EmployeeDetails } from "./EmployeeDetails";
import { MyTeamInfo } from "./MyTeamInfo";
import { KRAInfo } from "./KRAInfo";
export const EmployeeInformation = (props: any) => {
    const [audit, setAudit] = useState(new Array<AuditTrialVM>());
    useEffect(() => {
        Audit.GetAuditDetails(props.id).then((resp) => {
            setAudit(resp.data); 
        })
    }, [])
    
return(
<div className="row">
<div className="col-4"><EmployeeDetails id={props.id} /></div>
<div className="col-2"><EditInfo id={props.id}/></div>
<div className="col-6"><KRAInfo id={props.id} /><br/>
<MyTeamInfo id={props.id}  /><br/>

<AuditInfo data={audit} />
</div>
</div>
    )
}